<template>
    <div id="app-logo">
          <img id="app-logo" :src="logo" @click="openLink(link)" class="header-image" :title=link alt="start image" />
  </div>
</template>

<script>

const methods= {
    openLink(url) {
      console.log("openLink:" + url + " | main link: " + this.$store.state.logoLinkout);
      if(this.$store.state.logoLinkout != "undefined") {

        window.open(this.$store.state.logoLinkout);
      }
    }
  }
export default {
    props:['logo','link'],
      methods: methods,
}
</script>
